<template>
  <Cgq v-if="!newCom" v-bind="$attrs" />
  <CgqNew v-else v-bind="$attrs" />
</template>

<script>
import Cgq from "./cgq.vue";
import CgqNew from "./cgq_new";

export default {
  components: { Cgq, CgqNew },
  data() {
    return {
      no: localStorage.getItem("no") ? localStorage.getItem("no") : "", // 记录的设备号
      newCom: false,
      loading: true
    };
  },
  props: {
    deviceChange: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    deviceChange: {
      deep: true,
      handler(v) {
        if (v) {
          const no = localStorage.getItem("no");
          this.no = no;
          this.queryFarm();
        }
      }
    },
    refreshing(bl) {
      bl && this.queryFarm();
    }
  },

  mounted() {
    this.queryFarm();
  },

  methods: {
    async queryFarm() {
      this.loading = true;
      await this.$api.queryFarm(this.no).then(res => {
        if (res.errcode == 0 && res.data) {
          this.newCom = true;
        } else {
          this.newCom = false;
        }
        console.log("newCom: ", this.newCom);
        this.$forceUpdate();
      });

      this.loading = false;
    }
  }
};
</script>

<style></style>
